<template>
  <div class="stack-container">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="stack-heading">
          <div class="tc-title">{{ stack.name }}</div>
          <div class="stack-toolbar">
            <pc-leg-switch-with-value
              class="d-inline-block"
              v-model="stackConsent"
              :settings="settings"
              :label-on="settings.labelBtOn"
              :label-off="settings.labelBtOff"
              :reverse-position="true"
            ></pc-leg-switch-with-value>
            <a class="pointer d-inline-block detail-toggle" @click="toggleDisplay()">
              {{ displayDetails ? $t('hideDetails') : $t('seeDetails') }}
              <span v-show="displayDetails" class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
              <span v-show="!displayDetails" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
            </a>
          </div>
        </div>
      </div>
      <div class="panel-body" v-show="displayDetails">
        <p>{{ stack.description }}</p>
      </div>
      <ul v-show="displayDetails" class="list-group">
        <li class="list-group-item" v-for="purpose in stack.purposes" :key="`s${stack.id}p${purpose.id}`">
          <pc-leg-iab-category-block
            :category="purpose"
            v-show="displayDetails"
            @show-related-vendors="$listeners['show-related-vendors']"
          ></pc-leg-iab-category-block>
        </li>
        <li
          class="list-group-item"
          v-for="specialFeature in stack.specialFeatures"
          :key="`s${stack.id}p${specialFeature.id}`"
        >
          <pc-leg-iab-category-block :category="specialFeature"></pc-leg-iab-category-block>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import PcLegSwitchWithValue from '@/components/forms/pc-leg-switch-with-value';
import PcLegIabCategoryBlock from '@/components/providers/iab/pc-leg-iab-category-block';
import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { eventEmitterMixin } from '@/common/messaging/event-emitter-mixin';

export default {
  components: {
    PcLegSwitchWithValue,
    PcLegIabCategoryBlock,
  },
  mixins: [i18nMixin, eventEmitterMixin],
  props: {
    stack: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      displayDetails: false,
    };
  },
  computed: {
    purposeConsents: {
      get() {
        if (this.stack.purposes.length === 0) {
          return;
        }
        const first = this.stack.purposes[0].consent;
        return this.stack.purposes.every(p => p.consent === first) ? first : null;
      },
      set(value) {
        for (const purpose of this.stack.purposes) {
          purpose.consent = value;
          this.emitConsentChanged(purpose);
        }
      },
    },
    specialFeatureConsents: {
      get() {
        if (this.stack.specialFeatures.length === 0) {
          return;
        }
        const first = this.stack.specialFeatures[0].consent;
        return this.stack.specialFeatures.every(p => p.consent === first) ? first : null;
      },
      set(value) {
        for (const specialFeature of this.stack.specialFeatures) {
          specialFeature.consent = value;
          this.emitConsentChanged(specialFeature);
        }
      },
    },
    stackConsent: {
      get() {
        if (this.stack.purposes.length > 0 && this.stack.specialFeatures.length > 0) {
          if (this.purposeConsents && this.specialFeatureConsents) {
            return true;
          }
          if (this.purposeConsents === false && this.specialFeatureConsents === false) {
            return false;
          }
          return null;
        } else {
          return this.stack.purposes.length > 0 ? this.purposeConsents : this.specialFeatureConsents;
        }
      },
      set(value) {
        this.purposeConsents = value;
        this.specialFeatureConsents = value;
      },
    },
  },
  methods: {
    toggleDisplay() {
      this.displayDetails = !this.displayDetails;
    },
  },
};
</script>
<style lang="less">
@import '~bootstrap/less/variables.less';

.stack-container {
  padding: 1rem;
  color: @text-color;

  .category-description {
    color: @text-color;
  }
  .detail-toggle {
    margin-left: 1rem;
  }
  .stack-heading {
    display: flex;
    justify-content: space-between;

    .stack-toolbar {
      flex-basis: content;
      flex-shrink: 0;
    }
  }
}
</style>
